export default "__VITE_ASSET__BhuBrHcL__"